<template>
  <div id="preview" class="takeout">
    <div class="printTitle"><span>{{range.start}} </span><span v-if="range.start!==range.end">~</span><span v-if="range.start!==range.end"> {{ range.end }}</span> 外帶預約列表</div>
    <div class="printCount">
      <div></div>
      <div>總人數: {{reduce(rows.map(e => (e.reserveNum||0)+(e.reserveNumChild||0)))}}</div>
      <div>大人: {{reduce(rows.map(e => (e.reserveNum||0)))}}</div>
      <div>小孩: {{reduce(rows.map(e => (e.reserveNumChild||0)))}}</div>
      <div></div>
    </div>
    <div class="each" v-for="(row, r) in rows" :key="r">
      <div :style="{whiteSpace:'nowrap'}">{{row.status}}</div>
      <div :style="{alignItems:'center'}">
        <div :style="{whiteSpace:'nowrap'}">{{toDate(row.visitDate)}}</div>
        <div :style="{fontWeight:700}">{{row.visitTime}}</div>
      </div>
      <div>
        <div>{{row.agencyID}}</div>
        <div>{{row.agencyName}}</div>
      </div>
      <div>
        <div v-if="row.project">專案: {{row.project}}</div>
        <div >預約人: {{row.orderer}}</div>
        <div >電話: {{row.ordererTel||row.member||row.recipientTel||'-'}}</div>
      </div>
      <div>
        <div :style="{whiteSpace:'nowrap', fontWeight:700}" v-if="row.reserveNum">{{row.reserveNum}}大<span v-if="row.reserveNumChild">{{row.reserveNumChild}}小</span></div>
        <div>{{reduce(row.Orders.map(e => e.count))||'-'}}</div>
      </div>
      <div :style="{alignItems:'center'}">
        <div :style="{whiteSpace:'nowrap'}">業務</div>
        <div>{{row.salesman?.name||'-'}}</div>
      </div>
      <div :style="{justifyContent: 'flex-start'}">
        <div>備註: {{row.remark||'-'}}</div>
        <div>內部備註: {{row.remarkKitchen||'-'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['rows', 'range']

}
</script>

<style id="printRestInstore">
.printTitle {
  text-align: center;
  font-size: 18px;
  letter-spacing: 2px;
}
.printCount {
  border: 1px solid #CACACA;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  margin-top: 16px;
}
.printCount>div{
  flex:1;
  text-align: center;
}
.each {
  display: grid;
  grid-template-columns: 1fr 1.2fr 2fr 2fr 1fr 1fr 4fr;
  border: 1px solid #CACACA;
  margin-top: 10px;
  min-height: 85px;
  page-break-inside: avoid;
}
.each>div:not(:last-child) {
  border-right: 1px solid #CACACA;
}
.each>div {
  flex:1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  text-align: start;
  padding: 5px 10px;
  font-size: smaller;
}
</style>
